/* Copyright 2013 - 2024 Waiterio LLC */
import { css } from '@emotion/react'

export default css({
  label: 'elevated',
  boxShadow: '0 1.5px 4px rgba(0, 0, 0, 0.24), 0 0.5px 2px rgba(0, 0, 0, 0.19)',
})
